/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Community_MemberInputs */

const en_profile_community_member = /** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Member`)
};

const es_profile_community_member = /** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembro de la Comunidad`)
};

const fr_profile_community_member = /** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membre de la communauté`)
};

const de_profile_community_member = /** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Mitglied`)
};

const id_profile_community_member = /** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota Komunitas`)
};

/** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */
const ja_profile_community_member = en_profile_community_member;

/** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */
const zh_profile_community_member = en_profile_community_member;

/** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */
const ar_profile_community_member = en_profile_community_member;

/** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */
const it_profile_community_member = en_profile_community_member;

/** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */
const ru_profile_community_member = en_profile_community_member;

/** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */
const pt_profile_community_member = en_profile_community_member;

/** @type {(inputs: Profile_Community_MemberInputs) => LocalizedString} */
const ko_profile_community_member = en_profile_community_member;

/**
* | output |
* | --- |
* | "Community Member" |
*
* @param {Profile_Community_MemberInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_community_member = /** @type {((inputs?: Profile_Community_MemberInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Community_MemberInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_community_member(inputs)
	if (locale === "es") return es_profile_community_member(inputs)
	if (locale === "fr") return fr_profile_community_member(inputs)
	if (locale === "de") return de_profile_community_member(inputs)
	if (locale === "ja") return ja_profile_community_member(inputs)
	if (locale === "zh") return zh_profile_community_member(inputs)
	if (locale === "ar") return ar_profile_community_member(inputs)
	if (locale === "id") return id_profile_community_member(inputs)
	if (locale === "it") return it_profile_community_member(inputs)
	if (locale === "ru") return ru_profile_community_member(inputs)
	if (locale === "pt") return pt_profile_community_member(inputs)
	return ko_profile_community_member(inputs)
});